/* eslint-disable react/prop-types */ // TODO: add props
import { LinkedChecklist } from '../LinkedChecklist';
import ExemplarResponse from './ExemplarResponse';

export const ExemplarResponseChecklist = ({
  checklistItems,
  checklistReflections,
  onChecklistReflection,
  disabled,
  exemplarResponse,
  isSaving,
}) => {
  return (
    <LinkedChecklist
      checklistItems={checklistItems}
      checklistReflections={checklistReflections}
      onChecklistReflection={onChecklistReflection}
      renderLinkedComponent={(highlightedSerial) => (
        <ExemplarResponse
          body={exemplarResponse}
          highlightedItemSerial={highlightedSerial}
        />
      )}
      isSaving={isSaving}
    />
  );
};
